function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.1646 7.01632C29.8432 6.90552 30.4817 7.37057 30.5906 8.05504L31.4235 13.2881C31.5324 13.9726 31.0706 14.6173 30.3919 14.7281C29.7133 14.8389 29.0749 14.3738 28.9659 13.6894L28.1331 8.45627C28.0241 7.77181 28.486 7.12712 29.1646 7.01632Z",
  fill: "#FC8C41"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.4164 11.4549C20.886 10.948 21.6736 10.9206 22.1754 11.3938L25.8709 14.8776C26.3728 15.3507 26.3989 16.1452 25.9292 16.6521C25.4596 17.159 24.672 17.1864 24.1702 16.7132L20.4747 13.2294C19.9729 12.7563 19.9468 11.9618 20.4164 11.4549Z",
  fill: "#FC8C41"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.0004 21.1649C16.9829 20.4717 17.5257 19.8948 18.2129 19.8762L22.4493 19.7618C23.1364 19.7433 23.7076 20.2901 23.7251 20.9832C23.7425 21.6764 23.1997 22.2533 22.5126 22.2719L18.2762 22.3863C17.5891 22.4048 17.0179 21.858 17.0004 21.1649Z",
  fill: "#FC8C41"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42 30L26 30C22.6863 30 20 32.6863 20 36L20 46.5455L20 52C20 55.3137 22.6863 58 26 58L26.72 58L42 58C45.3137 58 48 55.3137 48 52L48 36C48 32.6863 45.3137 30 42 30Z",
  fill: "#FC8C41"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24 51C24 51 26.25 53 30 53C33.75 53 36 51 36 51",
  stroke: "#131416",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 45,
  r: 2,
  fill: "#131416"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 45,
  r: 2,
  fill: "#131416"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 16.25,
  y: 35.25,
  width: 27.5,
  height: 26.5,
  rx: 4.75,
  stroke: "#131416",
  strokeWidth: 2.5
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M21 35L21 33C21 29.6863 23.6863 27 27 27L45 27C48.3137 27 51 29.6863 51 33L51 50C51 53.3137 48.3137 56 45 56L44 56",
  stroke: "#131416",
  strokeWidth: 2.5
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M28 27L28 25C28 21.6863 30.6863 19 34 19L52 19C55.3137 19 58 21.6863 58 25L58 42C58 45.3137 55.3137 48 52 48L51 48",
  stroke: "#131416",
  strokeWidth: 2.5
});

function SvgAddIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.08ff6735.svg";
export { ForwardRef as ReactComponent };